/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddGroupEventRequest,
  CheckGroupEventDateRangeAvailabilityRequest,
  CheckGroupEventDateRangeAvailabilityResponse,
  IdResponse,
  UpdateGroupEventRequest,
} from '../models/index';

export interface GroupEventApiControllerAddGroupEventRequest {
    sellerId: string;
    AddGroupEventRequest: AddGroupEventRequest;
}

export interface GroupEventApiControllerCheckGroupEventDateRangeAvailabilityRequest {
    sellerId: string;
    CheckGroupEventDateRangeAvailabilityRequest: CheckGroupEventDateRangeAvailabilityRequest;
}

export interface GroupEventApiControllerDeleteGroupEventRequest {
    sellerId: string;
    groupEventId: string;
}

export interface GroupEventApiControllerUpdateGroupEventRequest {
    sellerId: string;
    groupEventId: string;
    UpdateGroupEventRequest: UpdateGroupEventRequest;
}

/**
 * 
 */
export class GroupEventApi extends runtime.BaseAPI {

    /**
     */
    async groupEventApiControllerAddGroupEventRaw(requestParameters: GroupEventApiControllerAddGroupEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling groupEventApiControllerAddGroupEvent().'
            );
        }

        if (requestParameters['AddGroupEventRequest'] == null) {
            throw new runtime.RequiredError(
                'AddGroupEventRequest',
                'Required parameter "AddGroupEventRequest" was null or undefined when calling groupEventApiControllerAddGroupEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/group-events`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddGroupEventRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async groupEventApiControllerAddGroupEvent(requestParameters: GroupEventApiControllerAddGroupEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdResponse> {
        const response = await this.groupEventApiControllerAddGroupEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async groupEventApiControllerCheckGroupEventDateRangeAvailabilityRaw(requestParameters: GroupEventApiControllerCheckGroupEventDateRangeAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckGroupEventDateRangeAvailabilityResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling groupEventApiControllerCheckGroupEventDateRangeAvailability().'
            );
        }

        if (requestParameters['CheckGroupEventDateRangeAvailabilityRequest'] == null) {
            throw new runtime.RequiredError(
                'CheckGroupEventDateRangeAvailabilityRequest',
                'Required parameter "CheckGroupEventDateRangeAvailabilityRequest" was null or undefined when calling groupEventApiControllerCheckGroupEventDateRangeAvailability().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/group-events/date-range-availability:check`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CheckGroupEventDateRangeAvailabilityRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async groupEventApiControllerCheckGroupEventDateRangeAvailability(requestParameters: GroupEventApiControllerCheckGroupEventDateRangeAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckGroupEventDateRangeAvailabilityResponse> {
        const response = await this.groupEventApiControllerCheckGroupEventDateRangeAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async groupEventApiControllerDeleteGroupEventRaw(requestParameters: GroupEventApiControllerDeleteGroupEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling groupEventApiControllerDeleteGroupEvent().'
            );
        }

        if (requestParameters['groupEventId'] == null) {
            throw new runtime.RequiredError(
                'groupEventId',
                'Required parameter "groupEventId" was null or undefined when calling groupEventApiControllerDeleteGroupEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/group-events/{groupEventId}`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"groupEventId"}}`, encodeURIComponent(String(requestParameters['groupEventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async groupEventApiControllerDeleteGroupEvent(requestParameters: GroupEventApiControllerDeleteGroupEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.groupEventApiControllerDeleteGroupEventRaw(requestParameters, initOverrides);
    }

    /**
     */
    async groupEventApiControllerUpdateGroupEventRaw(requestParameters: GroupEventApiControllerUpdateGroupEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling groupEventApiControllerUpdateGroupEvent().'
            );
        }

        if (requestParameters['groupEventId'] == null) {
            throw new runtime.RequiredError(
                'groupEventId',
                'Required parameter "groupEventId" was null or undefined when calling groupEventApiControllerUpdateGroupEvent().'
            );
        }

        if (requestParameters['UpdateGroupEventRequest'] == null) {
            throw new runtime.RequiredError(
                'UpdateGroupEventRequest',
                'Required parameter "UpdateGroupEventRequest" was null or undefined when calling groupEventApiControllerUpdateGroupEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/group-events/{groupEventId}`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"groupEventId"}}`, encodeURIComponent(String(requestParameters['groupEventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateGroupEventRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async groupEventApiControllerUpdateGroupEvent(requestParameters: GroupEventApiControllerUpdateGroupEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.groupEventApiControllerUpdateGroupEventRaw(requestParameters, initOverrides);
    }

}
